fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
    .then(response => response.json())
    .then(data => {
        const countryCode = data.detected_values.country.handle; // e.g., "us", "ca"
        if (countryCode !== "US" && countryCode !== "CA" && countryCode !== "BD") {
            document.querySelectorAll("#load-plans").forEach(el => el.classList.add("checked"));
            document.querySelectorAll("#plan-available-text").forEach(el => el.innerText = "In the US or Canada?");
            document.querySelectorAll(".regional").forEach((el) => {
                el.closest(".it-products-wrapper").style.display = "none";
            });
            document.querySelector(".international").closest(".it-products-wrapper").style.display = "block";
            if (document.getElementsByClassName("it-hero").length > 0) {
                document.querySelector(".it-hero").style.display = "none";
            }
        } else {
            document.querySelector(".international").closest(".it-products-wrapper").style.display = "none";
        }
        document.querySelector("body").classList.remove("body-loader");
    })
    .catch(error => console.error("Error fetching location data:", error));